import { Products } from "../interfaces";

export const PRODUCT_CODES = {
  [Products.PIX4Dcatch]: 'pix4dcatch',
  [Products.PIX4Dfields]: 'pix4dfields',
  [Products.PIX4Dmatic]: 'pix4dmatic2',
  [Products.PIX4Dreact]: 'pix4dreact',
  [Products.PIX4Dengine]: 'pix4dengine',
  [Products.PIX4Dmapper]: 'pix4d_mapper',
} as const;

export interface SoftwareValues {
  release_version: string;
  preview_version: string;
}

export const fetchSoftwareVersion = async (
  product: Products,
): Promise<SoftwareValues | null> => {
  try {
    const res = await fetch(
      `${process.env.GATSBY_CLOUD_API_URL}download_release/${[PRODUCT_CODES[product]]}/latest/version/`
    );

    if (!res.ok) throw new Error('Failed to fetch data');

    const data: SoftwareValues = await res.json();

    return data;
  } catch (err) {
    console.error('Error fetching HubDB data:', err);
    return null;
  }
};